import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Screen shake and camera kicks on heavy blows. */
    shake: boolean;
  }
}

defineSetting({
  key: 'shake',
  default: true,
  order: 40,
  menu: { group: 'visual', label: 'จอสั่นและกล้องกระแทก' },
});
